module.exports = __webpack_public_path__ + "img/아크엔젤.313f1a04.png";